/* eslint-disable prefer-const */
/* eslint-disable no-trailing-spaces */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { DateTimePage } from '../models/date-time/date-time.page';
import { LocalStorageService } from '../services/core/local-storage.service';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-add-reservation',
  templateUrl: './add-reservation.page.html',
  styleUrls: ['./add-reservation.page.scss'],
})
export class AddReservationPage implements OnInit {
  selectedDate:any
  timeSlots=[];
  activeTimeSlot;
  FirstName
  LastName
  Email
  Phone;
  occasion;
  reserveForm: FormGroup;
  isSubmitted = false;

  constructor(private modalController: ModalController,
    private fb:FormBuilder,
    private localStorageService:LocalStorageService, private server:UserApiService,public globals:GlobalVariable) { }

  ngOnInit() {
    this.reserveForm = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
      firstname: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      phone: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      lastname: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      date: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      time: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      occasion: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      persons: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      instructions: new FormControl(
        '',
      ),
      
    });
    if(this.globals.udid){
      this.FirstName = this.localStorageService.getFirstName('FirstName');
      this.LastName = this.localStorageService.getLastName('LastName');
      this.Email = this.localStorageService.getEmail('Email');
      this.Phone = this.localStorageService.getPhone('Phone');
      if(this.Phone){
        const match = this.Phone.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
        if (match) {
          // console.log(match)
          this.Phone =
            '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
        
          
        }
      }
    
    this.reserveForm.get('firstname').setValue(this.FirstName);
    this.reserveForm.get('lastname').setValue(this.LastName);
    this.reserveForm.get('email').setValue(this.Email);
    this.reserveForm.get('phone').setValue(this.Phone);


     
    }
    
  }
  get errorControl() {
    return this.reserveForm.controls;
  }
  async opendateModal(){
    let modal = await this.modalController.create({
      component:DateTimePage,
      cssClass:'datetimeModal'

    })
    modal.present();
    modal.onDidDismiss().then(res=>{
      console.log(res);
      if(res.data){
        this.selectedDate=res.data.date;
        this.getSlots();
      }
      
    })

  }
  selected(e){
    console.log(e.detail.value)
    this.activeTimeSlot=e.detail.value

  }
  numberChange() {
    console.log('here');
    // this.formatedPhone=''
    let elem =<HTMLIonInputElement>document.getElementById('text_input');
    // elem.focus()
    console.log(elem)
    let length=String(elem.value).length
    console.log(length)
    elem.setFocus()
    // tick()
      // elem.setSelectionRange(length,length)
    // elem.
  
    // this.phonenumber = String(phonenumber);
    console.log(this.reserveForm.value.phone,'form')
    var cleaned = (this.reserveForm.value.phone).replace(/\D/g, '');
    console.log(cleaned)
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      // console.log(match)
      this.Phone =
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
    
      
    }
  
    return null;
    
  }
  close(){
    this.modalController.dismiss()
  }
  getSlots(){
    this.globals.loader();

    this.server.getPickupslots
    (
      this.globals.bussinessId,
      this.selectedDate,
      'reservation'
    ).subscribe(res=>{
      console.log(res);
      this.globals.dismiss();
      if(res.status){
        this.timeSlots=res.slots
      }
      else{
        this.globals.presentToast('No time slots available, Try Different date')
      }
    },err=>{
      this.globals.dismiss();
    })
  }
  submit(){
    console.log(this.reserveForm.value);
    let cleanEmail=this.reserveForm.value.email.trim();
    this.reserveForm.get('email').setValue(cleanEmail);
    this.isSubmitted = true;
    if (!this.reserveForm.valid) {
    // var cleaned = ('' + this.reserveForm.value.phone).replace(/\D/g, '');

      // console.log('Please provide all the required values!');
      this.globals.presentToast('Some fields are missing. Please consider filling them first.')
      return
    } else {
      console.log(this.reserveForm.value);
      this.globals.loader();

      this.server.submitReservation(this.reserveForm.value).subscribe(res=>{
        console.log(res);
        this.globals.dismiss();
        if(res.success){
          this.globals.presentToast('Your request is submitted.');
          this.modalController.dismiss('success')
        }
        else{
          this.globals.presentToast('Failed to submit your request. please try again');

        }
      },err=>{
        this.globals.dismiss();
        this.globals.presentToast('Network error');

      })
    }

    
  }
}
